import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import type { ColumnType } from 'antd/es/table';

import { DragButton } from '@/shared/components';

import type { IFAQItemData } from './types';

export const getColumnsData = ({
  openEditQuestionModal,
  openDeleteQuestionModal,
  setItemToOperate,
}: {
  openEditQuestionModal: VoidFunction;
  openDeleteQuestionModal: VoidFunction;
  setItemToOperate: (data: IFAQItemData | null) => void;
}) =>
  [
    {
      title: 'Вопрос',
      dataIndex: 'question',
      key: 'question',
      ellipsis: true,
    },
    {
      title: 'Ответ',
      dataIndex: 'answer',
      key: 'answer',
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'options',
      key: 'options',
      width: 216,
      render: (_, { id, answer, position, question }) => (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <DragButton rowKey={position} />
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, answer, position, question });
              openEditQuestionModal();
            }}
          >
            <EditOutlined style={{ fontSize: '20px' }} />
          </Button>
          <Button
            onClick={(event) => {
              event.stopPropagation();

              setItemToOperate({ id, answer, position, question });
              openDeleteQuestionModal();
            }}
          >
            <DeleteOutlined style={{ fontSize: '20px' }} />
          </Button>
        </div>
      ),
      fixed: 'right',
    },
  ] as ColumnType<IFAQItemData>[];
